import moment from 'moment';

export const getUserDateParam = () => {
  return {
    userDate: moment().format('YYYY-MM-DD'),
  };
};
